import journal from '../img/journal.png'
import React from 'react';
import FrontRecapitulatif from './recapitulatif';
import FrontFooter from './footer'
import FrontProgress from './progress';

export default class FrontSubscribeError extends React.Component {
    
    constructor(props) {
        super(props);
    }

    render() {
        const params = this.props.devis.params
        const container = {
            devis:this.props.devis,
            changeParams:this.props.changeParams,
            setPage: this.props.setPage
        }
        return <>
        <FrontProgress comparateursCompleted={true} setPage={this.props.setPage} page={this.props.page} topRef={this.props.topRef}/>
        <div className="container">

            <div className="contentbox">
                <div className="contentvbox">
                    <p className="main_line">
                    Désolé, la souscription de ce contrat n'est pas possible en ligne&nbsp;:
                    </p>
                    {( this.props.embeded/* ||( container.devis.status_process=='presubscribe_error' )*/)?
                    <>
                    <p className="error">
                        {params.error}
                    </p>
                    <p>
                        <a className="button button_subscribe" onClick={this.props.restart}>
                            Réssayer <span>▸</span>
                        </a>
                    </p></>:''}
                    <p className="main_line">
                        Nous prenons contact avec vous le plus rapidement possible pour finaliser ensemble la souscription.
                        <br/>
                        N'hésitez pas à nous contacter par téléphone directement.
                    </p>
                    <p className="main_line">Contactez nous par téléphone</p>
                    <a href="tel:0974772861" className="tel">09 74 77 28 61</a>

                </div>
            </div>
            <div className="contentbox_middle"/>

            <div className="contentbox contentbox_right">
                <FrontRecapitulatif api={this.props.api} devis={this.props.devis} container={container}/>
            </div>
            </div>
            <FrontFooter/>            

        </>
    }
}